import * as React from 'react';

const ChatSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 5c3.3 0 6 2.7 6 6s-2.7 6-6 6h-1.6L12 18.5 10.4 17H9c-3.3 0-6-2.7-6-6s2.7-6 6-6h6m0-1H9c-3.9 0-7 3.1-7 7s3.1 7 7 7h1l2 2 1.8-2H15c3.9 0 7-3.1 7-7s-3.1-7-7-7"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M11 10h2v2h-2zM15 10h2v2h-2zM7 10h2v2H7z" />
        </g>
    </svg>
);

ChatSvg.displayName = 'ChatSvg';
export default ChatSvg;
